import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cancel-authorization",
  "use": "icon-cancel-authorization-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cancel-authorization\"><defs><style type=\"text/css\"></style></defs><path d=\"M547.281279 106.445908L229.508937 242.634055v209.941674c0 192.903104 136.188147 380.146754 317.772342 425.542803 181.584196-45.396049 317.772342-226.980245 317.772343-425.542803V242.634055L547.281279 106.445908z m60.748824 385.866416l121.497649 121.497648-60.748824 60.748824L547.281279 553.061148l-121.497648 121.497648-60.748824-60.748824 121.497648-121.497648-121.557855-121.557856 60.748824-60.748824L547.281279 431.5635 668.778928 310.065851l60.748824 60.748824-121.497649 121.497649z\" p-id=\"17960\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cancel-authorization.svg
// module id = 44ET
// module chunks = 3